import React from "react";
import { usePermissions } from "../../../../context/PermissionsContext";

const SplitOrder = ({ data }) => {

  const {Permissions} = usePermissions();



  return (
    <div className="uk-grid" uk-grid="">
      <div className="uk-width-1-1">
        <div className="analyticsTableWrp uk-margin-top">
          <table className="uk-table  uk-table-hover">
            <thead className="dropdownsum">
              <tr>
                <th>Product</th>
                <th>Variant</th>
                <th>Variant Price</th>
                <th>Exterior Color</th>
                <th>Interior Color</th>
                {/* <th>Color Price</th> */}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{data.variant.productName || '-'}</td>
                <td>{data.variant.variantName || '-'}</td>


                <td>Rs {new Intl.NumberFormat('en-PK', {
                              minimumFractionDigits: 0, 
                              maximumFractionDigits: 0
                              }).format(data.variant.variantPrice || '-')}</td>




                <td>{data.variant.exteriorColorName || '-'}</td>
                <td>{data.variant.interiorColorName || '-'}</td>
                {/* <td>{data.variant.colorComboPrice || '-'}</td> */}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SplitOrder;
